import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { clearTrackingEvents, launchProductOffering } from '../../actions/SmartConversion';
import * as Constants from '../../constants';
import { ICON_WIDTH, TRACKING_EVENTS } from '../../constants/SmartConversion';
import { getCurrentTrackingEvents, hitTrackingUrls } from '../../lib/SmartConversionUtils';

import {
  ModalBody,
  ModalContainer,
  ModalIcon,
  ModalSingleButton,
  ModalTitle,
  ModalXRow,
} from './Modal';

import './ModalUpsell.scss';

export class ModalUpsell extends React.Component {
  static propTypes = {
    title: PropTypes.node.isRequired,
    body: PropTypes.node.isRequired,
    ctaText: PropTypes.string.isRequired,
    productOffered: PropTypes.string.isRequired,
    iconSvgBitmap: PropTypes.string,
    imageUrl: PropTypes.string,
    onClose: PropTypes.func,
    trackingEvents: PropTypes.instanceOf(Map).isRequired,
    launchProductOffering: PropTypes.func.isRequired,
    clearTrackingEvents: PropTypes.func.isRequired,
  };

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentDidMount() {
    hitTrackingUrls(this.props.trackingEvents.get(TRACKING_EVENTS.IMPRESSION));
    this.timer = setTimeout(() => {
      this.onModalClose({ isManual: false });
    }, Constants.SmartConversion.SMC_DISMISS_TIMEOUT_MS);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  onEngagement = () => {
    hitTrackingUrls(this.props.trackingEvents.get(TRACKING_EVENTS.ENGAGEMENT));
    this.props.launchProductOffering(this.props.productOffered);
    this.onModalClose({ doTrackEvent: false });
  };

  onModalClose = ({ isManual, doTrackEvent = true }) => {
    if (doTrackEvent) {
      if (isManual) {
        hitTrackingUrls(this.props.trackingEvents.get(TRACKING_EVENTS.CLICK));
      } else {
        hitTrackingUrls(this.props.trackingEvents.get(TRACKING_EVENTS.DISMISS));
      }
      this.props.clearTrackingEvents();
    }
    this.props.onClose();
  };

  render() {
    const { title, body } = this.props;

    return (
      <ModalContainer className='Modal--upsell'>
        <ModalXRow
          onClose={() => {
            this.onModalClose({ isManual: true });
          }}
        />
        <ModalIcon
          svgBitmap={this.props.iconSvgBitmap}
          imageUrl={this.props.imageUrl}
          length={ICON_WIDTH}
        />
        <div className='Modal__container--rightSide'>
          <div className='Modal__container__text'>
            <ModalTitle>{title}</ModalTitle>
            <ModalBody>{body}</ModalBody>
          </div>
          <div className='Modal__container__button'>
            <ModalSingleButton
              isInline={true}
              text={this.props.ctaText}
              action={this.onEngagement}
            />
          </div>
        </div>
      </ModalContainer>
    );
  }
}

export function mapStateToProps(state) {
  const props = {};
  props.trackingEvents = getCurrentTrackingEvents(state);
  return props;
}

export default connect(mapStateToProps, {
  launchProductOffering,
  clearTrackingEvents,
})(ModalUpsell);
